export default class PhotoCarousel {
  constructor(carouselSelector, itemClass, gap = 16) {
    this.$carousel = document.querySelector(carouselSelector);
    this.$carouselWrapper = document.querySelector('.js-tour-photo-carousel__wrapper');
    this.$track = this.$carousel?.querySelector('.js-tour-photo-carousel__track');
    this.items = this.$carousel
      ? Array.from(this.$carousel.querySelectorAll(itemClass))
      : [];
    this.$leftArrow = this.$carousel?.querySelector('.js-tour-photo-carousel__arrow--left');
    this.$rightArrow = this.$carousel?.querySelector('.js-tour-photo-carousel__arrow--right');
    this.gap = gap;
    this.index = 0;
  }

  initiate() {
    if (!this.$carousel) {
      return;
    }

    if (this.$track.scrollWidth <= this.$carousel.offsetWidth) {
      this.$leftArrow?.classList.add('hid');
      this.$rightArrow?.classList.add('hid');
      this.$carouselWrapper?.classList.remove('ao-tour-customer-photos__carousel-wrapper--before');
      this.$carouselWrapper?.classList.remove('ao-tour-customer-photos__carousel-wrapper--after');

      return;
    }
    this.updateTrackPosition('start');
    this.attachEvents();
  }

  attachEvents() {
    this.$rightArrow.addEventListener('click', () => this.scroll('right'));
    this.$leftArrow.addEventListener('click', () => this.scroll('left'));
  }

  scroll(direction) {
    if (direction === 'right' && this.index < this.items.length - 1) {
      this.index += 1;
      this.updatePosition('middle');
      this.checkTrackPosition('right');
    } else if (direction === 'left' && this.index > 0) {
      this.index -= 1;
      const position = this.index === 0 ? 'start' : 'middle';
      this.updatePosition(position);
    }
  }

  updatePosition(position) {
    const carouselWidth = this.$carousel.offsetWidth;
    const scrollLeft = this.items.slice(0, this.index).reduce((total) => total + (carouselWidth / 3), 0);

    this.$track.style.transform = `translateX(-${scrollLeft}px)`;
    this.updateTrackPosition(position);
  }

  updateTrackPosition(position) {
    const isAtStart = position === 'start';
    const isAtEnd = position === 'end';

    this.$leftArrow?.classList.toggle('fade', isAtStart);
    this.$rightArrow?.classList.toggle('fade', isAtEnd);
    this.$carouselWrapper?.classList.toggle('ao-tour-customer-photos__carousel-wrapper--before', !isAtStart);
    this.$carouselWrapper?.classList.toggle('ao-tour-customer-photos__carousel-wrapper--after', !isAtEnd);
  }

  checkTrackPosition(direction) {
    requestAnimationFrame(() => {
      const trackWidth = this.$track.scrollWidth;
      const trackLeft = Math.abs(parseInt(this.$track.style.transform.replace('translateX(', '').replace('px)', ''), 10) || 0);
      const containerWidth = this.$carousel.offsetWidth;

      if (trackLeft + containerWidth >= trackWidth) {
        this.updateTrackPosition('end');
      } else if (direction === 'right') {
        this.updateTrackPosition('middle');
      }
    });
  }
}
